<template>

	<li class="mega-menu mega-menu-parent nav-item"
		:class="{ 'active': parentItem.active, 'mega-menu-parent--opened': shouldBeSeen }" @mouseenter="open()"
		@mouseleave="close()">
		<span class="d-flex flex-wrap align-items-center w-100">
			<a :href="parentItem.url" class="nav-link flex-1">{{ parentItem.name}}</a>
			<slot name="arrow"></slot>
		</span>
		<slot></slot>
		<portal to="mega-menu-holder">
			<div class="mega-menu-content" v-if="shouldBeSeen" @mouseenter="open()" @mouseleave="close()">
				<div class="d-flex w-100 px-3 py-5 bg-gray-1 align-items-start">
					<div class="families-list order-2 pl-4 ml-2 border-left border-secondary position-relative">
						<div class="h4 pb-1" v-text="parentItem.name"></div>
						<ul class="list-unstyled">
							<li v-for="item in items"><a :href="item.url" v-text="item.name"></a></li>
						</ul>
						<a :href="parentItem.url" class="families-list--link d-block w-100 text-right"> {{ seeAllString
							}}</a>
					</div>
					<div class="selected-families row order-1 flex-grow-1">
						<div v-for="item in items.slice(0, 4)" class="col-6 pr-lg-5 pb-5">
							<a :href="item.url" class="media">
								<img :src="item.thumbUrl" alt="" v-if="item.thumbUrl" class="mr-3"/>
								<span class="media-body">
									<span class="d-block pb-1 h4" v-text="item.name"></span>
									<span class="d-block" v-html="item.description"></span>
								</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</portal>
	</li>

</template>

<script>
	export default {
		props: {
			parentItem: Object,
			items: Array
		},

		data() {
			return {
				opened: false,
				seeAllString: '>>>',
				openingTimeout: null,
			}
		},

		computed: {
			active() {
				return this.$mq != 'mobile';
			},
			shouldBeSeen() {
				return this.opened && this.$root.menuIsOpened
			}
		},

		mounted() {
			this.seeAllString = (this.$root._lng == '_en')
					? 'All Categories >'
					: 'לכל הקטגוריות >';
		},

		methods: {
			open() {
				if (!this.active) {
					return;
				}

				this.$root.openMenu(this.parentItem.id);
				this.opened = true;
			},

			close() {
				if (!this.active) {
					return;
				}

				this.$root.closeMenu(this.parentItem.id);
				this.opened = false;
			},
		}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MegaMenu.vue